export function getURLSearchParamsFromQuery(query: {
  [key: string]: string | string[] | undefined;
}) {
  const tuples = Object.entries(query).flatMap(([key, value]) => {
    if (Array.isArray(value)) {
      return value.map((v) => [key, v]);
    } else if (typeof value === 'string') {
      return [[key, value]];
    } else {
      return [[key, '']];
    }
  });

  return new URLSearchParams(tuples);
}
